import React, {ReactElement} from 'react';
import {EventKind} from 'services/analytics';
import {lazy} from 'shared/utils/lazy';
import {compose} from 'shared/utils/compose';
import {toReadable} from 'shared/utils/number';

import {isEmpty} from 'core/History';
import {useUIStore, toggleUndo} from 'store/UI';
import {useHistoryStore} from 'store/History';
import {useDispatch} from 'ui/store';

import {PressEventProvider, PressEventProps} from 'components/PressEventProvider';
import {DeleteRecord, DeleteRecordProps} from 'ui/adapters/Core';
import {useAnalytics} from 'ui/adapters/Analytics';
import {Container} from './style';

export const Undo = (): ReactElement => {
  const history = useHistoryStore();
  const uiState = useUIStore();
  const hideButton = useDispatch(toggleUndo);
  const registerEvent = useAnalytics(EventKind.CancelSpend);

  if (isEmpty(history) || !uiState.undoButtonVisible) return null;

  const lastRecord = history[history.length - 1];
  const amount = toReadable(lastRecord.amount);

  return (
    <DeleteRecord>
      {({deleteRecord}: DeleteRecordProps) => (
        <PressEventProvider
          onPress={compose(lazy(deleteRecord, lastRecord), hideButton, registerEvent)}
        >
          {(props: PressEventProps) => <Container {...props}>Вернуть {amount}</Container>}
        </PressEventProvider>
      )}
    </DeleteRecord>
  );
};
